export const getLoadingIndicator = (state: any) => state.api.loadingIndicator.loadingIndicatorVisible;
